import { Box, CardContent } from '@mui/material'
import React from 'react'

const HomeWorkout = () => {
  return (
    <Box sx={{display:"flex",justifyContent:"center",mt:{xs:"20%",lg:"10%"}}}>
      <CardContent sx={{transform:"rotate(-10deg)",fontSize:{xs:"34px",md:"44px"},fontWeight:"bold",}}>
      Development Mode
      </CardContent>
    </Box>
  )
}

export default HomeWorkout
